import DOMPurify from "isomorphic-dompurify";
import { CardProps } from "@/components/molecules/card";
import { Box, Heading, Text } from "@chakra-ui/react";
import styles from "../../molecules/richTextComponent/richTextComponent.module.scss";
import DownloadLinks from "@/components/molecules/downloadLinks/DownloadLinks";

export interface DownloadBlockProps {
  items: CardProps[];
  title: string;
  description?: string;
}

export const DownloadBlock = ({
  items,
  title,
  description,
}: DownloadBlockProps) => {
  return (
    <Box w="full">
      <Box display="flex" flexDirection="column" gap={5} mb={10}>
        <Heading
          as={"h2"}
          textStyle="display.md"
          fontWeight={400}
          color={"brand.aubergine"}
          className={styles.title}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(title.replace(/<\/p>/g, "</br>"), {
              ALLOWED_TAGS: ["strong", "br"],
            }),
          }}
        />
        {description && <Text textStyle="paragraph.md">{description}</Text>}
      </Box>
      <DownloadLinks downloads={items} />
    </Box>
  );
};
